import { Command } from 'commander';
import { ConnectContextService } from '../../../services/connect-context.service.js';
import { ConnectPolicyService } from '../../../services/connect-policy.service.js';
import { ConnectExecService } from '../../../services/connect-exec.service.js';
import { assertEnvName } from '../shared.js';

interface GetOptions {
    json?: boolean;
}

export function createConnectCacheGetCommand(): Command {
    return new Command('get')
        .description('Get cache value by key')
        .argument('<env>', 'Environment')
        .argument('<connection>', 'Connection name (redis|valkey)')
        .argument('<key>', 'Cache key')
        .option('-j, --json', 'Output JSON')
        .action(function (this: Command, envRaw: string, connectionName: string, key: string, options: GetOptions) {
            const env = assertEnvName(envRaw);
            const useJson = !!(options.json || this.optsWithGlobals().json);
            const context = new ConnectContextService();
            const settings = context.getSettings();
            const connection = context.getConnection(env, connectionName);
            if (!connection) throw new Error(`Connection '${connectionName}' not found in ${env}`);
            if (!['redis', 'valkey'].includes(connection.runtime)) {
                throw new Error(`Connection '${connection.name}' is not a cache runtime`);
            }

            const policy = new ConnectPolicyService(settings).evaluate(env, connection.runtime, 'read');
            if (!policy.allowed) throw new Error(`Permission denied: ${policy.reason}`);

            const output = new ConnectExecService().runCacheGet(connection, key).trimEnd();
            if (useJson) {
                console.log(JSON.stringify({ env, connection: connection.name, key, value: output }, null, 2));
                return;
            }
            console.log(output);
        });
}
